<template>
  <div class="peer-self-container">
    <div v-if="peer" class="peer-self">
      <v-icon class="device device-icon">{{icon}}</v-icon>
      <div class="name">
        <span :title="peer.name.userName">{{userName}}</span><br>
        <small>{{device}}</small>
      </div>
    </div>
  </div>
</template>

<script>
  import {getDeviceName, getDeviceIcon, getUserName} from './peer-utils';


  export default {
    name: 'PeerSelf',

    computed: {
      peer() {
        return this.$store.getters['share/getPeerSelf'];
      },

      device() {
        return getDeviceName(this.peer);
      },

      icon() {
        return getDeviceIcon(this.peer);
      },

      userName() {
        return getUserName(this.peer);
      }
    }
  };
</script>
